import ErrorAlert from "@/utility/ErrorAlert";
import http from "@/axios/http-common";

import { MppRequest, MppResponseItem, SkriningResponseItem } from "@/types/mpp";

async function create(data: MppRequest, cat_id: string) {
  const response = await http.postData(`/mpp/${cat_id}`, data).catch(err => {
    ErrorAlert.showErrorAlert(err);

    return Promise.reject(err);
  });

  return response.data.data;
}

async function update(id: number, data: MppRequest, cat_id: string) {
  const response = await http
    .putData(`/mpp/${cat_id}/${id}`, data)
    .catch(err => {
      ErrorAlert.showErrorAlert(err);

      return Promise.reject(err);
    });

  return response.data.data;
}

async function getByRegister(
  register_id: string | number,
  cat_id: string
): Promise<{ status: number; data: MppResponseItem[] }> {
  const response = await http
    .getData(`/register/${register_id}/mpp/${cat_id}`)
    .catch(err => {
      ErrorAlert.showErrorAlert(err);

      return Promise.reject(err);
    });

  return response.data;
}

async function getDataSkrining(): Promise<SkriningResponseItem[]> {
  try {
    const response = await http.getData("/referensi/mpp/skrining");

    return response.data.data || response.data;
  } catch (err) {
    console.error("Error API:", err);
    throw err;
  }
}

async function destroy(id: number, cat_id: string, alasan: string) {
  const response = await http
    .deleteDataParam(`/mpp/${cat_id}/${id}`, {
      params: {
        alasan: alasan
      }
    })
    .catch(err => {
      ErrorAlert.showErrorAlert(err);

      return Promise.reject(err);
    });

  return response.data;
}

async function verify(id: number) {
  const response = await http
    .postData(`/rencana-askep/${id}/verifikasi`, {})
    .catch(err => {
      ErrorAlert.showErrorAlert(err);

      return Promise.reject(err);
    });

  return response.data;
}

export default {
  create,
  update,
  getByRegister,
  destroy,
  verify,
  getDataSkrining
};
